export default __webpack_public_path__ + "static/media/ferramenta3.518fd910.png";